import { bindActionCreators, Dispatch } from "redux";
import { useMemo } from "react";
import { ActionCreators } from "../state";

export const useActions = (dispatch: Dispatch<any>) => {
  return useMemo(
    () => bindActionCreators(ActionCreators, dispatch),
    [dispatch]
  );
};
